import { RiShoppingCartLine } from '@react-icons/all-files/ri/RiShoppingCartLine'

// shopping cart related things (add buttons, open buttons, ...)

export const IconCart = RiShoppingCartLine
